
const Constantes = ( () => {
    // ERICK
    const PATH_API = `${process.env.API_URL_ONLINE}/tiendaOnlineWS/rest/application/`
    //produccion
    //const PATH_API = `${process.env.API_URL_ONLINE}/tiendaOnlineWS/rest/application/`
    
    const KEY_GOOGLE_MAP = `${process.env.API_URL_GOOGLE}`


    //const URL_EMAIL = "WebsiteWS/rest/service/sendMail";

    const URL_EMAIL = "https://www.empeñofacil.com/WebsiteWS/rest/service/sendMail";
    

    return {
        PATH_API,
        KEY_GOOGLE_MAP,
        URL_EMAIL
    };
})();

export default Constantes;